import api from './api';
import type { WineListSection, WineListSectionVisibility } from '../types/venue';

const base = (venueId: string, wineListId: string) =>
  `/admin/venue/${venueId}/wine-list/${wineListId}/sections`;

export interface CreateSectionPayload {
  name: string;
  description?: string;
  position?: number;
  visibility?: WineListSectionVisibility;
}

export type UpdateSectionPayload = Partial<CreateSectionPayload> & { active?: boolean };

const wineListSectionService = {
  /** List active sections for a wine list, ordered by position. */
  getSections: async (
    venueId: string,
    wineListId: string,
  ): Promise<WineListSection[]> => {
    const response = await api.get(base(venueId, wineListId));
    return response.data;
  },

  /** Create a new section on a wine list. */
  createSection: async (
    venueId: string,
    wineListId: string,
    data: CreateSectionPayload,
  ): Promise<WineListSection> => {
    const response = await api.post(base(venueId, wineListId), data);
    return response.data;
  },

  /** Partial update of a section. */
  updateSection: async (
    venueId: string,
    wineListId: string,
    sectionId: string,
    data: UpdateSectionPayload,
  ): Promise<WineListSection> => {
    const response = await api.patch(`${base(venueId, wineListId)}/${sectionId}`, data);
    return response.data;
  },

  /** Soft-delete a section. Items previously in this section become unsectioned. */
  deleteSection: async (
    venueId: string,
    wineListId: string,
    sectionId: string,
  ): Promise<void> => {
    await api.delete(`${base(venueId, wineListId)}/${sectionId}`);
  },
};

export default wineListSectionService;
